import { api } from './client'

/**
 * R4-03 (REQ-220-001): storico delle versioni di configurazione (`GET /api/config-versions`). Solo Admin e solo con il flag
 * `config.versioni_estese` acceso: per gli altri la rotta risponde 403/404 e la UI non mostra il pulsante.
 */
export type ConfigEntityType =
  | 'Contest' | 'Target' | 'CallScript' | 'Pipeline' | 'DocumentTemplate' | 'RequiredDocument' | 'ProductRule'

export interface ConfigFieldChange {
  field: string
  before: string | null
  after: string | null
}

export interface ConfigVersionEntry {
  id: number
  version: number
  validFrom: string
  createdAt: string
  createdByUserId: number | null
  reason: string
  changes: ConfigFieldChange[]
  snapshot: Record<string, string | null>
}

export const configVersionsApi = {
  types: () => api<string[]>('/api/config-versions/types'),
  list: (entityType: ConfigEntityType, entityId: number) =>
    api<ConfigVersionEntry[]>(`/api/config-versions/${entityType}/${entityId}`),
}

let availability: Promise<boolean> | null = null

/** Vero se l'utente puo' leggere lo storico (admin e flag acceso). Una sola richiesta per sessione di pagina. */
export function configVersionsAvailable(): Promise<boolean> {
  availability ??= configVersionsApi.types().then(() => true, () => false)
  return availability
}
